<template>
    <div class="cms-content-slice bg bg--light-blue">
        <div class="container">
            <div class="cms-content-slice-latest-offers">
                <div class="business-offer__content">
                    <h2 class="cms-content-heading">{{ contentSlice.content_1 }}</h2>

                    <p>{{ contentSlice.content_2 }}</p>

                    <div class="business-offer-filters">
                        <SliderSelectDropdown v-if="initialFilters.bodystyle" id="bodystyle" option-key="bodystyle" :event="{ category: 'Business & Fleet', label: 'Filter by Body Style' }">
                            Body Style
                        </SliderSelectDropdown>

                        <SliderSelectDropdown v-if="initialFilters.manufacturer" id="manufacturer" option-key="manufacturer" :event="{ category: 'Business & Fleet', label: 'Filter by Manufacturer' }">
                            Manufacturer
                        </SliderSelectDropdown>

                        <MinMaxSliderDropdown v-if="initialFilters.minMonthlyPayment && initialFilters.maxMonthlyPayment" id="budgetDropRange" min-key="minMonthlyPayment" max-key="maxMonthlyPayment" :step="100" :financial="true" :event="{ category: 'Business & Fleet', label: 'Budget Clicked' }">
                            Budget
                        </MinMaxSliderDropdown>

                        <LoadingSpinner v-show="isFirstLoad === false && isLoading" :style="{ height: '40px', marginRight: 'auto', width: 'min-content' }" />
                    </div>
                    <div class="business-swiper__nav-group">
                        <div class="swiper-offer__slider-nav--prev">
                            <svg class="business-swiper__nav-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" height="45px" width="45px">
                                <path d="M22.5 0C34.926 0 45 10.074 45 22.5S34.926 45 22.5 45 0 34.926 0 22.5 10.074 0 22.5 0Zm0 1.5c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21-9.402-21-21-21Z"></path>
                                <path d="M24.424 13.52a.75.75 0 1 1 1.152.96l-6.6 7.908 6.6 7.907a.75.75 0 0 1-.016.98l-.08.077a.75.75 0 0 1-1.056-.096l-7-8.388a.75.75 0 0 1 0-.96l7-8.389Z"></path>
                            </svg>
                        </div>
                        <div class="offer-card__swiper swiper business-swiper">
                            <div class="swiper-wrapper swiper-container">
                                <template v-if="newVehicles.length === 0 && isLoading">
                                    <div :style="{ margin: 'auto', paddingBottom: '10px' }">
                                        <LoadingSpinner />
                                    </div>
                                </template>
                                <template v-else-if="newVehicles.length === 0 && !isLoading">
                                    <p>No offers found matching your criteria.</p>
                                </template>
                                <template v-else>
                                    <LatestBusinessOffer v-for="newVehicle in newVehicles" :key="newVehicle.id" :vehicle="newVehicle" @match-height="handleMatchHeight" />
                                </template>
                            </div>
                        </div>
                        <div class="swiper-offer__slider-nav--next">
                            <svg class="business-swiper__nav-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" height="45px" width="45px">
                                <path d="M22.5 0C34.926 0 45 10.074 45 22.5S34.926 45 22.5 45 0 34.926 0 22.5 10.074 0 22.5 0Zm0 1.5c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21-9.402-21-21-21Z"></path>
                                <path d="M21.576 13.52a.75.75 0 1 0-1.152.96l6.6 7.908-6.6 7.907a.75.75 0 0 0 .016.98l.08.077a.75.75 0 0 0 1.056-.096l7-8.388a.75.75 0 0 0 0-.96l-7-8.389Z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="business-discover-offers">
                <a class="btn btn--has-primary-icon btn--primary" href="/business/offers">
                    Discover All Offers
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { debounce } from 'lodash';
import Swiper, { Navigation } from "swiper";
import { mapState, mapActions, mapMutations } from 'vuex';
import LatestBusinessOffer from './LatestBusinessOffer.vue';
import SliderSelectDropdown from './SliderSelectDropdown.vue';
import MinMaxSliderDropdown from './MinMaxSliderDropdown.vue';
import LoadingSpinner from '../../../used-vue/components/Buy-Online/LoadingSpinner.vue';

export default {
    name: "LatestBusinessOffers",
    components: {
        LatestBusinessOffer,
        SliderSelectDropdown,
        MinMaxSliderDropdown,
        LoadingSpinner,
    },
    props: {
        contentSlice: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            isLoading: true,
            isFirstLoad: true,
            swiperInstance: null,
            newVehicles: [],
        };
    },
    computed: {
        ...mapState(['initialFilters', 'sliderFilters']),
    },
    methods: {
        ...mapActions(['getInitialFilters']),
        ...mapMutations(['setInitialFilters', 'setSliderFilters']),
        search() {
            this.isLoading = true;
            const filters = Object.fromEntries(Object.entries(this.sliderFilters).filter(([_key, value]) => value !== null));

            filters.monthlyPayment = {
                "min": filters.minMonthlyPayment,
                "max": filters.maxMonthlyPayment,
            };
            delete filters.minMonthlyPayment;
            delete filters.maxMonthlyPayment;

            axios.post('/api/business', filters).then((response) => {
                this.newVehicles = response.data;
            }).finally(() => {
                this.isLoading = false;
                this.isFirstLoad = false;

                if (this.newVehicles && this.newVehicles.length > 0 && !this.swiperInstance) {
                    this.$nextTick(() => {
                        this.initialiseLatestOffersSlider();
                    });
                } else if (this.swiperInstance) {
                    this.$nextTick(() => {
                        this.swiperInstance.update();
                        this.swiperInstance.updateSlides();
                    });
                }
            });
        },
        initialiseLatestOffersSlider: () => {
            const offersSlices = document.querySelectorAll('.cms-content-slice-latest-offers');
            const offersSliceLength = offersSlices.length;

            if (offersSliceLength <= 0) {
                return;
            }

            for (let index = 0; index < offersSliceLength; index++) {
                const slider = offersSlices[index].querySelector('.offer-card__swiper');

                if (slider) {
                    this.swiperInstance = new Swiper(slider, {
                        modules: [Navigation],
                        grabCursor: true,
                        slidesPerView: 1,
                        spaceBetween: 30,
                        rewind: true,
                        navigation: {
                            nextEl: '.swiper-offer__slider-nav--next',
                            prevEl: '.swiper-offer__slider-nav--prev',
                        },
                        breakpoints: {
                            576: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 3,
                            },
                        }
                    });
                }
            }
        },
        handleMatchHeight: debounce(function () {
            $('.swiper-slide').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false,
            });
        }, 50),
        getQueryParameter(key) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(key);
        }
    },
    watch: {
        sliderFilters: {
            deep: true,
            handler: debounce(function () { this.search() }, 1000)
        },
        contentSlice: {
            deep: true,
            handler: function (newValue) {
                this.newVehicles = newValue.cmsOffers;
            }
        },
    },
    created() {
        this.getInitialFilters();
    },
}
</script>

<style lang="scss">
@import "../../../../sass/redesign/variables";

.gallery-image-wrapper {
    position: relative;
    width: 100%;
    height: auto;
    display: block;
}

/* Reserve a 16:10 area. Use aspect-ratio where available; fallback to padding-top.
   16:10 = 1.6 -> padding-top = 62.5% (10/16 = 0.625) */
.gallery-image-outer {
    position: relative;
    width: 100%;
    /* modern browsers */
    aspect-ratio: 16 / 10;
}

/* Fallback for browsers that don't support aspect-ratio */
.gallery-image-outer::before {
    content: '';
    display: block;
    padding-top: 62.5%;
}

.gallery-image-inner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    border-top-left-radius: $default-card-border-radius;
    border-top-right-radius: $default-card-border-radius;
}

.gallery-image-inner picture,
.gallery-image-inner img {
    width: 100%;
    height: 100%;
}

.gallery-image-inner img.img-responsive {
    display: block;
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.gallery-image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.6);
    border-top-left-radius: $default-card-border-radius;
    border-top-right-radius: $default-card-border-radius;
}

.gallery-spinner .spinner-svg {
    width: 48px;
    height: 48px;
}

.gallery-spinner .path {
    stroke: #0093D6;
    stroke-linecap: round;
    animation: rotate 1s linear infinite;
}

@keyframes rotate {
    0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
    }

    100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
    }
}

.gallery-image-overlay.gallery-error {
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
}

.gallery-error-inner {
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    font-size: 14px;
}

.search-results-vehicle {
    &__swiper-container {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 20px;
        padding-left: 12px;
        padding-right: 12px;
    }

    &__colour-swiper {
        flex-basis: calc(100% - 118px);
        padding: 5px;

        .swiper-slide {
            width: auto;
            display: inline-flex;
            align-items: center;
        }
    }

    &__swiper-btn {
        flex-basis: 49px;
        flex-grow: 0;
        flex-shrink: 0;
        height: 49px;
        cursor: pointer;
        transform: scale(1.0);
        transition: 150ms transform ease-in-out, 150ms opacity ease-in-out;

        &--disabled {
            opacity: 0.3;
            cursor: initial;
        }

        &.swiper-button-lock {
            display: block;
        }
    }

    &__swiper-prev {
        background-image: url(/images/new/details/left-arrow.svg);

        &:hover {
            transform: scale(1.05);
        }
    }

    &__swiper-next {
        background-image: url(/images/new/details/right-arrow.svg);

        &:hover {
            transform: scale(1.05);
        }
    }

    &__paint-btn {
        flex-grow: 0;
        flex-shrink: 0;
        width: 45px;
        height: 45px;
        border: 1px solid #0C93FF;
        border-radius: 45px;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: 150ms box-shadow ease-in;
        box-shadow: 0 0 0 0 #0C93FF, inset 0 0 0 0 #0C93FF;

        &:hover {
            box-shadow: 0 0 3px 0 #0C93FF, inset 0 0 3px 0 #0C93FF;
        }

        &--active {
            box-shadow: 0 0 5px 0 #0C93FF, inset 0 0 5px 0 #0C93FF;
        }
    }

    &__paint-btn-inner {
        flex-grow: 0;
        flex-shrink: 0;
        width: 25px;
        height: 25px;
        border-radius: 25px;
        background-color: #DFDFDF;
    }

    &__nav-button--disabled {
        opacity: 0.3;
        pointer-events: none;
    }

    &__exclusive-offer-badge {
        position: absolute;
        bottom: 5px;
        left: 20px;
        background: #5EB565;
        border-radius: 4px;
        padding: 5px 7px;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        gap: 6px;

        img {
            width: 19px;
        }
    }

    &__no-img {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
    }
}
</style>